import { Box, Image, Text, Timer } from '@bonanza-social/moonlight';
import { useSelector } from '@bonanza-social/toolkit/state';
import { useEffect, useMemo } from 'react';
import { selectRegistrationConfig } from '../../../../state';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

function TimerSection() {
  const config = useSelector(selectRegistrationConfig);
  const rotation = useSharedValue(0);

  useEffect(() => {
    rotation.value = withRepeat(
      withTiming(-20, {
        duration: 500,
        easing: Easing.inOut(Easing.ease),
      }),
      -1,
      true,
    );
  }, [rotation]);

  const timer = useMemo(() => {
    if (config.countdownTimer) {
      return Math.floor(Date.now() / 1000) + config.countdownTimer;
    }
    return null;
  }, [config.countdownTimer]);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          rotate: `${rotation.value}deg`,
        },
      ],
    };
  });

  if (!timer) return null;

  return (
    <Box flexDirection="row" gap="space-100" alignItems="center">
      <Box animatedStyle={animatedStyle}>
        <Image
          contentFit="contain"
          name="common.clockV2"
          width={22}
          height={22}
          priority="high"
          cachePolicy="memory-disk"
          transform={[{ rotate: '10deg' }]}
        />
      </Box>
      <Timer
        color="darkSurfacePrimary"
        format="clock"
        variant="body-s-semi"
        time={timer}
      />
      <Text variant="body-s-semi" color="darkSurfacePrimary">
        to claim {config.hideProgressBar && 'your bonus'}
      </Text>
    </Box>
  );
}

export default TimerSection;
